const countryIDs = {
  ru: '0',
  ua: '1',
  kz: '2',
  by: '3',
  other: '4',
};

export default countryIDs;
